import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
  },
  sectionTitle: {
    fontWeight: 600,
  },
  emphasisColor: {
    backgroundColor: theme.palette.background.default,
  },
  inlineBox: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  switchLabel: {
    marginTop: theme.spacing(1),
  },
  dateField: {
    marginTop: theme.spacing(2),
  },
}))

export default useStyles
